import React, { useEffect, useState } from "react";
import pikug from "../../assets/images/claim/pikug.svg";
import vepikug from "../../assets/images/claim/vepikug.svg";
import lockedpikug from "../../assets/images/claim/lockedpikug.svg";
import arrow from "../../assets/images/homePage/home_right_arrow.png";
import DatePicker from "react-datepicker";
import useTranslation from "../../Languages/Translation";
import { ethers, parseEther } from "ethers";
import {
  estimatePikuGRelaseAmaount, estimatePikuGRelaseAmaountFirstTime,
  getLockedPikuAmount, getLockedPikuTime,
  getPikuBalance,
  getPikuGBalance,
  getVePikuGAmount, incLockedPikugAmount, incLockedPikugTime,
  lockPikuG,
  lockPikuGFirstTime,
  pikuApprove,
  pikuGApprove
} from "../../Service/Web3/Web3Service";
import { useWeb3ModalAccount, useWeb3ModalProvider } from "@web3modal/ethers/react";
import error_icon from "../../assets/images/claim/erroricon.svg";
import { isFutureDate } from "../../utils";

const Lock = () => {
  // const signer = new ethers.BrowserProvider(window.ethereum).getSigner();
  const { walletProvider } = useWeb3ModalProvider()
  const { isConnected, address } = useWeb3ModalAccount()

  const [pay, setpay] = useState("");
  const [show, setShow] = useState(false);
  const [max, setMax] = useState(null);
  const [tab, setTab] = useState("1");
  const [startDate, setStartDate] = useState(null);
  const [filter, setfilter] = useState("");
  const translation = useTranslation();
  const [lockedAmount, setLockedAmount] = useState(null);
  const [pikuAmount, setPikuAmount] = useState(null);
  const [vePikuAmount, setVePikuAmount] = useState(null);
  const [loadingState, setLoadingState] = useState(0);
  const [isApproved, setApproved] = useState(false);
  const [lockedTime, setLockedTime] = useState(null);
  const [showfirst, setshowfirst] = useState(true)
  const [showAlert, setShowAlert] = useState(false);
  const [estimatedAmount, setEstimatedAmount] = useState("0");
  const [refreshEffect, setRefreshEffect] = useState(false);

  useEffect(() => {
    const fetchLockedAmount = async () => {
      const provider = new ethers.BrowserProvider(walletProvider)
      const signer = await provider.getSigner()
      const piku_balance = await getPikuGBalance(signer);
      const vePikugBalance = await getVePikuGAmount(signer);
      const lockedPikuAmount = await getLockedPikuAmount(signer);
      const lockedPikuTime = await getLockedPikuTime(signer);
      setLockedTime(lockedPikuTime);
      console.log(lockedPikuTime)
      console.log(0)
      if (lockedPikuTime == 0) {
        console.log(1)
        setStartDate(new Date());
        setLockedTime(new Date())
      } else {
        console.log(2)
        const date = new Date(Number(lockedPikuTime) * 1000);
        console.log(date)
        setStartDate(date);
        setLockedTime(date);
      }
      setVePikuAmount(parseFloat(vePikugBalance).toFixed(2));
      setLockedAmount(parseFloat(lockedPikuAmount).toFixed(2));
      setMax(parseFloat(piku_balance).toFixed(2))
      setPikuAmount(parseFloat(piku_balance).toFixed(2));
      if (lockedPikuAmount > 0) {
        setshowfirst(false)
      }
    };
    if (walletProvider && isConnected) {
      fetchLockedAmount();
    }
  }, [walletProvider, isConnected, refreshEffect]);

  useEffect(() => {
    if (startDate === null) {
      return;
    }
    handleEstimate(startDate.toString());
  }, [pay]); // 'pay' değiştiğinde handleEstimate'i çağır

  const onChangeHandler = async (e) => {
    const value = e.target.value;
    if (/^\d*\.?\d*$/.test(value)) {
      const trimmedValue = value.trimStart();
      if (trimmedValue === "") {
        setpay("");
      } else {
        const numericValue = parseFloat(trimmedValue);
        setpay(numericValue.toString()); // Bu, bir sonraki render'da pay değerini günceller
      }
    }
  };


  const handlePikuGApprove = async (event) => {
    event.preventDefault();
    setLoadingState(1);
    try {
      const provider = new ethers.BrowserProvider(walletProvider)
      const signer = await provider.getSigner()
      await pikuGApprove(signer, pay);
      console.log("approvedsafsda");
      setApproved(true);
    } catch (e) {
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);
    } finally {
      setLoadingState(0);
    }
  }


  const handlePikuGLocked = async (event) => {
    event.preventDefault();
    console.log("locked")
    setLoadingState(2);
    const provider = new ethers.BrowserProvider(walletProvider)
    const signer = await provider.getSigner()
    try {
      if (showfirst) {
        await lockPikuGFirstTime(signer, pay.toString(), startDate);
      } else {
        await incLockedPikugAmount(signer, pay);
      }
      setpay("");
      setApproved(false);

    } catch (e) {
      console.log(e)
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);
    } finally {
      setRefreshEffect(!refreshEffect);
      setLoadingState(0);
    }
  }

  const handleIncDateChange = async (event) => {
    event.preventDefault();
    console.log("time increased")
    setLoadingState(2);

    const provider = new ethers.BrowserProvider(walletProvider)
    const signer = await provider.getSigner()
    try {
      let timestamp = startDate.getTime() / 1000;
      await incLockedPikugTime(signer, timestamp);
      setApproved(false);
    } catch (e) {
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);
    } finally {
      setRefreshEffect(!refreshEffect);
      setLoadingState(0);
    }
  }

  const handleEstimate = async (date) => {
    console.log(date);
    let provider = new ethers.BrowserProvider(walletProvider);
    let singer = await provider.getSigner();
    try {
      let estimateAmount;
      if (showfirst) {
        if (pay == 0) {
          return;
        }
        console.log("first time")
        estimateAmount = await estimatePikuGRelaseAmaountFirstTime(singer, parseEther(pay.toString()), date);
      } else {
        console.log("not first time")
        estimateAmount = await estimatePikuGRelaseAmaount(singer, date, vePikuAmount);
      }
      setEstimatedAmount(parseFloat(estimateAmount).toFixed(2).toString());
    } catch (e) {
      console.log(e)
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);
    }
  }

  const balancedlist = [
    {
      image: pikug,
      asset: "PikuG",
      amount: pikuAmount,
    },
    {
      image: vepikug,
      asset: "vePikuG",
      amount: vePikuAmount,
    },
    {
      image: lockedpikug,
      asset: "Locked PikuG",
      amount: lockedAmount,
    },
  ];

  const lockSchedule = [
    {
      year: "1 PikuG locked for 1 year",
      value: "0.25 vePikuG",
    },
    {
      year: "1 PikuG locked for 2 year",
      value: "0.5 vePikuG",
    },
    {
      year: "1 PikuG locked for 3 year",
      value: "0.75 vePikuG",
    },
    {
      year: "1 PikuG locked for 4 year",
      value: "1 vePikuG",
    },
  ];

  return (
    <div className=" main_container  pt-[90px] lg:pt-[120px]">
      {showAlert && (
        <div className="fixed top-24 left-1/2 transform -translate-x-1/2 bg-[#050505] text-white px-4 py-2 rounded-lg z-50 flex items-center shadow-lg border border-[#222222]">
          <div className="bg-red-500 rounded-full h-6 w-6 flex items-center justify-center mr-2">
            <img src={error_icon} alt="error icon" className="w-10 h-10" />
          </div>
          <span className="text-lg">An Error Occurred</span>
        </div>
      )}
      <div className="max-w-[520px] mx-auto ">
        <div className="p-[24px] lg:p-[32px] bg-[#222222] rounded-[24px]">
          <p className="text-[20px] lg:text-[24px] text-white aeonik_medium leading-[30px]">
            {translation.Balances}
          </p>
          <div className="pt-[12px] pb-[12px]">
            {balancedlist?.map((item, i) => (
              <div
                className="flex items-center justify-between mt-[12px]"
                key={i}
              >
                <div className="flex items-center">
                  <img
                    src={item.image}
                    alt="logo"
                    className="h-[32px] w-auto object-contain mr-[8px]"
                  />
                  <p className="lg:text-[18px] text-white aeonik_normal leading-[23px]">
                    {item.asset}
                  </p>
                </div>
                <p className="text-[18px] text-white aeonik_normal leading-[23px]">
                  {item.amount}
                </p>
              </div>
            ))}
          </div>
          {lockedAmount > 0 && <p className="text-[#9b9c9d] text-[14px] aeonik_normal leading-[21px] mt-[12px]">
            {"PikuG locked until " + lockedTime.toLocaleString()}
            <br /> GMT+03:00
            (GMT+03:00)
          </p>}
        </div>
        <div className="p-[24px] lg:p-[32px] bg-[#222222] rounded-[24px] mt-[16px] lg:mt-[24px]">
          <div>
            <p className="text-[20px] lg:text-[24px] text-white aeonik_medium leading-[30px]">
              {translation.LockPikuGforvePikuG}
            </p>
            <div
              className={`${show && "border-b-[1px] border-b-[#343434] pb-[8px]"
                }`}
            >
              <div
                className="flex items-center mb-[12px]  mt-[24px] cursor-pointer m-w-[143px]"
                onClick={() => setShow(!show)}
              >
                <p className="lg:text-[18px] text-white aeonik_medium leading-[23px]">
                  Lock Schedule
                </p>
                <img
                  src={arrow}
                  className={`ml-[8px] h-[14px] w-auto object-contain ${show === true ? " -rotate-90" : "rotate-90 "
                    }  transform`}
                />
              </div>
              {show &&
                lockSchedule?.map((items, i) => (
                  <div
                    className="flex items-center justify-between mb-[8px]"
                    key={i}
                  >
                    <p className="text-[#9b9c9d] text-[16px] aeonik_normal leading-[24px]">
                      {items.year}
                    </p>
                    <p className="text-white text-[16px] aeonik_medium leading-[24px] ">
                      {items.value}
                    </p>
                  </div>
                ))}
            </div>
          </div>
          {showfirst ?

            // Lock PikuG for vePikuG section


            <div className="">
              {/* <p className='text-[#9b9c9d] text-[16px] aeonik_normal leading-[24px]'>Lock</p> */}
              <form>
                <div className="mt-[16px] relative">
                  <label
                    name="lock"
                    className="text-[#9b9c9d] text-[14px] lg:text-[16px] aeonik_normal leading-[24px]"

                  >
                    Lock
                  </label>
                  <input
                    type="number"
                    placeholder="0.00"
                    className="w-full bg-[#1A1A1A]  px-[20px] py-[25px] text-[24px] aeonik_normal leading-[36px] text-white outline-none placeholder:text-[#484848] rounded-[8px] mt-[12px]"
                    value={pay}
                    onChange={onChangeHandler}
                    name="lock"
                    autoComplete="off"
                  />

                  <div className="absolute top-12 right-0 bg-[#1A1A1A] px-[20px]">
                    {pay.length > 0 ? (
                      <p className="text-[#9b9c9d] text-[14px] aeonik_normal leading-[21px] text-end">
                        Max: <span className="underline">{max}</span>
                      </p>
                    ) : (
                      <p className="text-[#9b9c9d] text-[14px] aeonik_normal leading-[21px] text-end">
                        Max: {pikuAmount}
                      </p>
                    )}
                    <div className="flex items-center mt-[8px]">
                      <img
                        src={pikug}
                        alt="logo"
                        className="h-[24px] w-auto object-contain mr-[8px]"
                      />
                      <p className="text-white text-[16px] aeonik_normal leading-[24px]">
                        PikuG
                      </p>
                    </div>
                  </div>
                </div>

                <div className="relative mt-[16px]">
                  <label
                    name="start time"
                    className="text-[#9b9c9d] text-[14px] lg:text-[16px] aeonik_normal leading-[24px]"

                  >
                    Lock Until
                  </label>
                  <DatePicker
                    selected={startDate}
                    onChange={async (date) => {
                      setStartDate(date);
                      await handleEstimate(date)
                    }}
                    viewMode="start time"
                    // dateFormat="MM/dd/YYYY"
                    placeHolder="MM/DD/YYYY"
                    autoComplete="off"
                    name="start time"
                    minDate={new Date(new Date().getTime() + 10 * 24 * 60 * 60 * 1000)}
                    className="text-white text-[24px] outline-none leading-[36px] w-full bg-[#1a1a1a] rounded-[8px] py-[16px] mt-[12px] placeholder:text-[#484848] pl-[20px] aeonik_normal"
                  />
                  <ul className="absolute right-[0px] px-[20px] py-[20px] z-50 bg-[#1a1a1a] top-[35px] flex items-center">
                    <li
                      onClick={async () => {
                        setfilter("1");
                        const lockDate = new Date(lockedTime);
                        lockDate.setMonth(lockDate.getMonth() + 6);
                        setStartDate(lockDate);
                        await handleEstimate(new Date(new Date().setMonth(lockedTime.getMonth() + 6)).toString());
                      }}
                      className={`${filter === "1"
                        ? "bg-[#222222] text-white"
                        : "text-[#8D8D8D]"
                        } py-[3px] px-[10px] text-[12px] aeonik_normal leading-[18px] rounded-[24px] border border-[#282828] mr-[4px] cursor-pointer z-[100]`}
                    >
                      6M
                    </li>
                    <li
                      onClick={async () => {
                        setfilter("2")
                        setStartDate(new Date(new Date().setFullYear(lockedTime.getFullYear() + 1)))
                        await handleEstimate(new Date(new Date().setFullYear(lockedTime.getFullYear() + 1)).toString());
                      }}
                      className={`${filter === "2"
                        ? "bg-[#222222] text-white"
                        : "text-[#8D8D8D]"
                        } py-[3px] px-[10px] text-[12px] aeonik_normal leading-[18px] rounded-[24px] border border-[#282828] mr-[4px] cursor-pointer z-[100]`}
                    >
                      1Y
                    </li>
                    <li
                      onClick={async () => {
                        setfilter("3")
                        setStartDate(new Date(new Date().setFullYear(lockedTime.getFullYear() + 2)))
                        await handleEstimate(new Date(new Date().setFullYear(lockedTime.getFullYear() + 2)).toString());
                      }}
                      className={`${filter === "3"
                        ? "bg-[#222222] text-white"
                        : "text-[#8D8D8D]"
                        } py-[3px] px-[10px] text-[12px] aeonik_normal leading-[18px] rounded-[24px] border border-[#282828] mr-[4px] cursor-pointer z-[100]`}
                    >
                      2Y
                    </li>
                    <li
                      onClick={async () => {
                        setfilter("4")
                        setStartDate(new Date(new Date().setFullYear(lockedTime.getFullYear() + 3)))
                        await handleEstimate(new Date(new Date().setFullYear(lockedTime.getFullYear() + 3)).toString());
                      }}
                      className={`${filter === "4"
                        ? "bg-[#222222] text-white"
                        : "text-[#8D8D8D]"
                        } py-[3px] px-[10px] text-[12px] aeonik_normal leading-[18px] rounded-[24px] border border-[#282828] mr-[4px] cursor-pointer z-[100]`}
                    >
                      3Y
                    </li>
                    <li
                      onClick={async () => {
                        setfilter("5")
                        setStartDate(new Date(new Date().setFullYear(lockedTime.getFullYear() + 4)))
                        await handleEstimate(new Date(new Date().setFullYear(lockedTime.getFullYear() + 4)).toString());
                      }}
                      className={`${filter === "5"
                        ? "bg-[#222222] text-white"
                        : "text-[#8D8D8D]"
                        } py-[3px] px-[10px] text-[12px] aeonik_normal leading-[18px] rounded-[24px] border border-[#282828] cursor-pointer z-[100]`}
                    >
                      4Y
                    </li>
                  </ul>
                </div>
                {startDate && (
                  <div className="flex justify-between mt-[16px]">
                    <p className="text-[16px] leading-[24px] aeonik_normal text-[#9b9c9d]">
                      You will receive
                    </p>
                    <p className="text-[16px] leading-[20px] aeonik_normal text-white">
                      {estimatedAmount} vePikuG
                    </p>
                  </div>
                )}

                <div className="mt-[32px]">
                  <button
                    className={`bg-[#282828] w-full py-[12px] rounded-[150px] flex justify-center text-[18px] aeonik_medium leading-[27px] ${pay.length && pay < Number(max) && isFutureDate(startDate) ? "bg-sky text-black cursor-pointer" : "text-white"
                      }`}
                    disabled={!pay.length || pay > Number(max) || loadingState || !isFutureDate(startDate)}
                    onClick={handlePikuGApprove}
                  >
                    {loadingState === 1 ? (
                      <span className="flex items-center">
                        <svg
                          className="animate-spin mr-2 h-5 w-5 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8v8h8a8 8 0 01-8 8v-8H4z"
                          ></path>
                        </svg>
                        Approving...
                      </span>
                    ) : isApproved ? (
                      <span>Approved PikuG</span>
                    ) : (
                      <span>1. Approve PikuG</span>
                    )}
                  </button>

                  <button
                    className={`mt-[12px] w-full py-[12px] rounded-[150px] flex justify-center text-[18px] ${isApproved ? "bg-sky text-black cursor-pointer" : "bg-[#282828] text-white"} aeonik_medium leading-[27px] cursor-pointer`}
                    onClick={handlePikuGLocked}
                    disabled={!isApproved}
                  >
                    {loadingState === 2 ? (
                      <span className="flex items-center">
                        <svg
                          className="animate-spin mr-2 h-5 w-5 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8v8h8a8 8 0 01-8 8v-8H4z"
                          ></path>
                        </svg>
                        Approving...
                      </span>
                    ) : (
                      <span>2. Lock PikuG</span>
                    )}
                  </button>

                </div>
              </form>
            </div>
            :
            <div>
              <p className="text-white text-[16px] aeonik_normal leading-[24px] mt-[12px] mb-[24px]">
                If you have locked PikuG already, you can only increase the amount
                of PikuG locked or the time locked.
              </p>
              <div>
                <div className="flex items-center justify-between bg-[#1A1A1A] p-[4px] rounded-[8px]">
                  <a
                    className={`${tab === "1" ? "bg-[#282828]" : ""
                      } rounded-[6px] px-[49px] py-[6px] cursor-pointer`}
                    onClick={() => setTab("1")}
                  >
                    <span className="text-[16px] text-white aeonik_medium leading-[20px]">
                      Increase Amount
                    </span>
                  </a>
                  <a
                    className={` ${tab === "2" ? "bg-[#282828]" : ""
                      } rounded-[6px] px-[60px] py-[6px] cursor-pointer`}
                    onClick={() => setTab("2")}
                  >
                    <span className="text-[16px] text-white aeonik_medium leading-[20px]">
                      Increase Time
                    </span>
                  </a>
                </div>
              </div>
              {tab === "1" ? (
                <div className="">
                  {/* <p className='text-[#9b9c9d] text-[16px] aeonik_normal leading-[24px]'>Lock</p> */}
                  <form>
                    <div className="mt-[16px] relative">
                      <label
                        name="lock"
                        className="text-[#9b9c9d] text-[16px] aeonik_normal leading-[24px]"
                      >
                        Lock
                      </label>
                      <input
                        type="number"
                        placeholder="0.00"
                        className="w-full bg-[#1A1A1A]  px-[20px] py-[25px] text-[24px] aeonik_normal leading-[36px] text-white outline-none placeholder:text-[#484848] rounded-[8px] mt-[12px]"
                        value={pay}
                        onChange={(e) => {
                          if (/^\d*\.?\d*$/.test(e.target.value)) {
                            setpay(e.target.value?.trimStart());
                          }
                        }}
                        name="lock"
                        autoComplete="off"
                      />

                      <div className="absolute top-12 right-0 bg-[#1A1A1A] px-[20px]">
                        {pay.length > 0 ? (
                          <p className="text-[#9b9c9d] text-[14px] aeonik_normal leading-[21px] text-end">
                            Max: <span className="underline">{max}</span>
                          </p>
                        ) : (
                          <p className="text-[#9b9c9d] text-[14px] aeonik_normal leading-[21px] text-end" onClick={() => (
                            setpay(max)
                          )}>
                            Max: {pikuAmount}
                          </p>
                        )}
                        <div className="flex items-center mt-[8px]">
                          <img
                            src={pikug}
                            alt="logo"
                            className="h-[24px] w-auto object-contain mr-[8px]"
                          />
                          <p className="text-white text-[16px] aeonik_normal leading-[24px]">
                            PikuG
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="mt-[32px]">
                      <button
                        className={`bg-[#282828] w-full py-[9px] lg:py-[12px] rounded-[150px] flex justify-center lg:text-[18px] aeonik_medium leading-[27px] ${pay.length && pay < Number(max) ? "bg-sky text-black cursor-pointer" : "text-white"
                          }`}
                        disabled={!pay.length || pay > Number(max) || loadingState}
                        onClick={handlePikuGApprove}
                      >
                        {loadingState === 1 ? (
                          <span className="flex items-center">
                            <svg
                              className="animate-spin mr-2 h-5 w-5 text-white"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                            >
                              <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                              ></circle>
                              <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8v8h8a8 8 0 01-8 8v-8H4z"
                              ></path>
                            </svg>
                            Approving...
                          </span>
                        ) : isApproved ? (
                          <span>Approved PikuG</span>
                        ) : (
                          <span>1.Approve PikuG</span>
                        )}
                      </button>

                      <button
                        className={`mt-[12px] w-full py-[9px] lg:py-[12px] rounded-[150px] flex justify-center lg:text-[18px] ${isApproved ? "bg-sky text-black cursor-pointer" : "bg-[#282828] text-white"} aeonik_medium leading-[27px] cursor-pointer`}
                        onClick={handlePikuGLocked}
                        disabled={!isApproved}
                      >
                        {loadingState === 2 ? (
                          <span className="flex items-center">
                            <svg
                              className="animate-spin mr-2 h-5 w-5 text-white"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                            >
                              <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                              ></circle>
                              <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8v8h8a8 8 0 01-8 8v-8H4z"
                              ></path>
                            </svg>
                            Transaction Pending...
                          </span>
                        ) : (
                          isApproved ? (
                            <span>{lockedAmount && lockedAmount == 0 ? 'Lock PikuG' : 'Increase Locked PikuG'}</span>
                          ) : (
                            <span>{lockedAmount && lockedAmount == 0 ? '2. Lock PikuG' : '2. Increase Locked PikuG'}</span>
                          )

                        )}
                      </button>

                    </div>
                  </form>
                </div>
              ) : (
                <form>
                  <div className="relative mt-[16px]">
                    <label
                      name="start time"
                      className="text-[#9b9c9d] text-[16px] aeonik_normal leading-[24px]"
                    >
                      Lock Until
                    </label>
                    <DatePicker
                      selected={startDate}
                      onChange={async (date) => {
                        setStartDate(date);
                        await handleEstimate(date);
                      }}
                      viewMode="start time"
                      // dateFormat="MM/dd/YYYY"
                      placeHolder="MM/DD/YYYY"
                      autoComplete="off"
                      name="start time"
                      minDate={new Date(lockedTime.getTime() + 10 * 24 * 60 * 60 * 1000)}
                      className="text-white text-[24px] outline-none leading-[36px] w-full bg-[#1a1a1a] rounded-[8px] py-[16px] mt-[12px] placeholder:text-[#484848] pl-[20px] aeonik_normal"
                    />
                    <ul className="absolute right-[0px] px-[20px] py-[20px] z-50 bg-[#1a1a1a] top-[35px] flex items-center">
                      <li
                        onClick={async () => {
                          setfilter("1");
                          const lockDate = new Date(lockedTime);
                          lockDate.setMonth(lockDate.getMonth() + 6);
                          setStartDate(lockDate);
                          await handleEstimate(lockDate);
                        }}
                        className={`${filter === "1"
                          ? "bg-[#222222] text-white"
                          : "text-[#8D8D8D]"
                          } py-[3px] px-[10px] text-[12px] aeonik_normal leading-[18px] rounded-[24px] border border-[#282828] mr-[4px] cursor-pointer z-[100]`}
                      >
                        6M
                      </li>
                      <li
                        onClick={async () => {
                          setfilter("2");
                          let newStartDate = new Date(lockedTime);
                          newStartDate.setFullYear(lockedTime.getFullYear() + 1);
                          setStartDate(newStartDate);
                          await handleEstimate(newStartDate.toString());
                        }}
                        className={`${filter === "2"
                          ? "bg-[#222222] text-white"
                          : "text-[#8D8D8D]"
                          } py-[3px] px-[10px] text-[12px] aeonik_normal leading-[18px] rounded-[24px] border border-[#282828] mr-[4px] cursor-pointer z-[100]`}
                      >
                        1Y
                      </li>
                      <li
                        onClick={async () => {
                          setfilter("3")
                          let newStartDate = new Date(lockedTime);
                          newStartDate.setFullYear(lockedTime.getFullYear() + 2);
                          setStartDate(newStartDate);
                          await handleEstimate(newStartDate.toString());
                        }}
                        className={`${filter === "3"
                          ? "bg-[#222222] text-white"
                          : "text-[#8D8D8D]"
                          } py-[3px] px-[10px] text-[12px] aeonik_normal leading-[18px] rounded-[24px] border border-[#282828] mr-[4px] cursor-pointer z-[100]`}
                      >
                        2Y
                      </li>
                      <li
                        onClick={async () => {
                          setfilter("4")
                          let newStartDate = new Date(lockedTime);
                          newStartDate.setFullYear(lockedTime.getFullYear() + 3);
                          setStartDate(newStartDate);
                          await handleEstimate(newStartDate.toString());
                        }}
                        className={`${filter === "4"
                          ? "bg-[#222222] text-white"
                          : "text-[#8D8D8D]"
                          } py-[3px] px-[10px] text-[12px] aeonik_normal leading-[18px] rounded-[24px] border border-[#282828] mr-[4px] cursor-pointer z-[100]`}
                      >
                        3Y
                      </li>
                      <li
                        onClick={async () => {
                          setfilter("5")
                          let newStartDate = new Date(lockedTime);
                          newStartDate.setFullYear(lockedTime.getFullYear() + 4);
                          setStartDate(newStartDate);
                          await handleEstimate(newStartDate.toString());
                        }}
                        className={`${filter === "5"
                          ? "bg-[#222222] text-white"
                          : "text-[#8D8D8D]"
                          } py-[3px] px-[10px] text-[12px] aeonik_normal leading-[18px] rounded-[24px] border border-[#282828] cursor-pointer z-[100]`}
                      >
                        4Y
                      </li>
                    </ul>
                  </div>
                  {startDate && (
                    <div className="flex justify-between mt-[16px]">
                      <p className="text-[16px] leading-[24px] aeonik_normal text-[#9b9c9d]">
                        You will receive
                      </p>
                      <p className="text-[16px] leading-[20px] aeonik_normal text-white">
                        {estimatedAmount} vePikuG
                      </p>
                    </div>
                  )}
                  <button
                    className={`mt-[32px] bg-[#282828] w-full py-[10px] lg:py-[12px] rounded-[150px] flex justify-center lg:text-[18px]  aeonik_medium leading-[27px] ${startDate
                      ? "bg-sky text-black cursor-pointer"
                      : "text-[#969696] "
                      } `}
                    disabled={!startDate}
                    onClick={handleIncDateChange}
                  >
                    {loadingState === 2 ? (
                      <span className="flex items-center">
                        <svg
                          className="animate-spin mr-2 h-5 w-5 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8v8h8a8 8 0 01-8 8v-8H4z"
                          ></path>
                        </svg>
                        Approving...
                      </span>
                    ) : (
                      <span>Increase Lock Duration</span>
                    )}
                  </button>
                </form>
              )}
            </div>}
        </div>

      </div>
    </div>
  );
};

export default Lock;
